import {cloneElement} from 'react';
import {connect} from 'react-redux';

const FileList = ({files, children}) => cloneElement(children, {files});

const mapStateToProps = ({media}, {ids}) => {
    const files = [];

    ids.forEach(id => {
        const {url, preview} = media[id];

        if (url) files.push(url);
        if (preview) files.push(preview);
    });

    return {files};
};

export default connect(mapStateToProps)(FileList);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/DownloadButton/FileList.js